module.exports = __webpack_public_path__ + "static/media/medical-record.5d1dc697.png";